import React, { Component } from 'react';
import Switch from "react-switch";

export default class ToggleSwitch extends Component {
    constructor() {
        super();
        this.state = { checked: false };
        // this.handleChange = this.handleChange.bind(this);
    }


    render() {
        // console.log(this.state.checked)
        // console.log("Props ", this.props)

        return (
            <div className="example">
                {/* <h2>Custom styling</h2> */}
                <label htmlFor="material-switch" style={{ display: 'flex', alignItems: 'center', marginBottom: '1.5rem' }}>
                    <span style={{ marginRight: '.5rem' }}>{this.props.label}</span>
                    <Switch
                        checked={this.props.value}
                        // onChange={(checked) => this.props.onchange(checked)}
                        onChange={this.props.onchange}
                        onColor="#86d3ff"
                        onHandleColor="#2693e6"
                        handleDiameter={30}
                        uncheckedIcon={false}
                        checkedIcon={false}
                        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                        activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                        height={20}
                        width={48}
                        className="react-switch"
                        id="material-switch"
                    />
                </label>
            </div>
        )
    }
}